export const PER_PALLET_UNIT_MEASURE = [
  `штука`,
  `штуки`,
  `штук`
];

export const PER_PACKAGE_UNIT_MEASURE = [
  `штука`,
  `штуки`,
  `штук`
];

export const PRICE_CURRENCY = `руб.`;
